import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/context/AuthContext";
import { FileDown, Sparkles, Loader2 } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Iter281 · Mejoras técnicas (ej. criterios de "Innovación tecnológica" de un
// pliego) con memoria descargable en Word para adjuntar a la propuesta.
export function OfferImprovements({ offerId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    axios.get(`${API}/offers/${offerId}/improvements`)
      .then(({ data }) => setItems(data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [offerId]);

  const download = async (imp) => {
    setDownloadingId(imp.id);
    try {
      const { data } = await axios.get(`${API}/offers/${offerId}/improvements/${imp.id}/docx`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `memoria_${imp.title.slice(0, 40).replace(/[^a-zA-Z0-9]+/g, "_")}.docx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      alert("No se pudo descargar la memoria. Inténtalo de nuevo.");
    }
    setDownloadingId(null);
  };

  if (loading || items.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 space-y-3" data-testid="offer-improvements-section">
      <h2 className="font-bold text-gray-900 font-['Outfit'] flex items-center gap-2">
        <Sparkles size={16} className="text-amber-500" /> Mejoras técnicas de la propuesta
      </h2>
      {items.map((imp) => (
        <div key={imp.id} className="flex items-center justify-between gap-3 border border-gray-100 rounded-lg p-3" data-testid={`improvement-item-${imp.id}`}>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-800 truncate">{imp.title}</p>
            <p className="text-xs text-gray-500">
              CAPEX +{fmt(imp.capex_add)} € · OPEX +{fmt(imp.opex_add)} €/año
            </p>
          </div>
          <button
            onClick={() => download(imp)}
            disabled={downloadingId === imp.id}
            className="flex items-center gap-1.5 text-xs border border-[#007934] text-[#007934] px-3 py-1.5 rounded-lg hover:bg-[#E8F5E9] font-medium whitespace-nowrap disabled:opacity-50"
            data-testid={`download-improvement-docx-${imp.id}`}
          >
            {downloadingId === imp.id ? <Loader2 size={12} className="animate-spin" /> : <FileDown size={12} />}
            Descargar memoria (Word)
          </button>
        </div>
      ))}
    </div>
  );
}
